import { defineMessages } from 'react-intl';

export const noReviewMessages = defineMessages({
  noReview: {
    id: 'reviews.no.review',
    defaultMessage: 'Tento produkt zatím nikdo nehodnotil, buďte první!',
  },
  noReviewSubtitle: {
    id: 'reviews.no.review.subtitle',
    defaultMessage:
      'Konstruktivní a upřímné hodnocení pomůže ostatním zákazníkům s výběrem. ',
  },
});
